import React from "react";
import "./header.css";
import { FormattedMessage } from "react-intl";
import { Tooltip } from "antd";
import HeaderAskImg from "../../../assets/img/bg-banner-ask.svg";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

const HeaderAsk = props => {
  const { myType, onNewClick } = props;

  const templates = useSelector(state => state.ask.templates.list);
  const buttonPlaceholderText = useIntl().formatMessage({ id: "ask.pages.edit.communityTemplates.createAskDotsButtonPlaceholder" });
  const buttonText = useIntl().formatMessage({ id: "ask.pages.edit.communityTemplates.createAskDotsButton" });
  const buttonPlaceholderTitleText = useIntl().formatMessage({ id: "ask.pages.edit.communityTemplates.createAskDotsButtonTitlePlaceholder" });

  return (
    <div
      className={"HeaderAsk-root" + (myType !== "STUDIO" ? " company" : "")}
      style={{
        background: `url(${HeaderAskImg}) no-repeat`,
        backgroundColor: "#fff"
      }}
    >
      <div className="Creare-ask-in">
        <FormattedMessage
          id={
            myType === "STUDIO"
              ? "ask.header.title1"
              : "ask.header.companyTitle1"
          }
        />{" "}
      </div>
      <div className="Creare-ask-label-black">
        <FormattedMessage
          id={
            myType === "STUDIO"
              ? "ask.header.subtitle1"
              : "ask.header.companySubtitle1"
          }
        />{" "}
      </div>
      {(myType === "STUDIO" ||
        (myType !== "STUDIO" && templates && templates.length > 0)) && (
        <div className="createAskButtonContainer">
          <Tooltip
            color={"rgb(0, 80, 117)"}
            placement="bottom"
            title={<>
              <div className="createAskButtonPlaceholderTitle">{buttonPlaceholderTitleText}</div>
              <div className="createAskButtonPlaceholder">{buttonPlaceholderText}</div></>}
          >
            <button className="createAskButton" onClick={() => onNewClick()}>
              {buttonText}
            </button>
          </Tooltip>
        </div>
        // <div className="Creare-ask-circle">
        //   <Tooltip
        //     placement="top"
        //     title={
        //       <FormattedMessage
        //         id={
        //           myType === "STUDIO"
        //             ? "ask.tooltips.addNewAsk"
        //             : "ask.tooltips.addNewAskCompany"
        //         }
        //       />
        //     }
        //   >
        //     <div className="TS-button-circle" onClick={() => onNewClick()}>
        //       <FontAwesomeIcon
        //         icon={["far", "plus"]}
        //         style={{ fontSize: "23px", color: "white", margin: "0 auto" }}
        //       />
        //     </div>
        //   </Tooltip>
        // </div>
      )}
    </div>
  );
};

export default HeaderAsk;
